import React, { memo } from 'react'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'

function FormUsers__Details(props) {
    const { formik } = props

    return (
        <React.Fragment>
            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"First Name"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"First Name"} // placeholder for the input
                formikFieldName={"editUserFirstName"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Last Name"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Last Name"} // placeholder for the input
                formikFieldName={"editUserLastName"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Email"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Email"} // placeholder for the input
                formikFieldName={"editUserEmail"} // important: formik value name for the input
                inputType={"email"}
            />

            {/* form field */}
            <AppFormikSelectInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Two Facto"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                formikFieldName={"editUserTwoFactor"} // important: formik value name for the input
            >
                <option disabled value="">Select Two Factor</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
            </AppFormikSelectInline>

            {/* form field */}
            <AppFormikSelectInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Type"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                formikFieldName={"editUserType"} // important: formik value name for the input
            >
                <option value="">Select Type</option>
                {
                    (props.adminGroups && props.adminGroups.length) && props.adminGroups.map(item => (
                        <option
                            key={item.group_id.toString()}
                            value={item.group_id.toString()}>{item.group_name}</option>
                    ))
                }</AppFormikSelectInline>

            {/* form field */}
            <AppFormikSelectInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Status"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                formikFieldName={"editUserStatus"} // important: formik value name for the input
            >
                <option disabled value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
            </AppFormikSelectInline>
        </React.Fragment>
    )
}

export default memo(FormUsers__Details)